import styles from "./styles.module.scss";
import Setting from "@assets/icons/setting";

interface ProductActionsProps {
  setIsOpenModal?: (value: boolean) => void;
  isDetails: boolean;
  isTable?: boolean;
}

export const ProductActions = ({
  setIsOpenModal,
  isTable,
}: ProductActionsProps) => {
  return (
    <div className={styles.productActions}>
      {!isTable && (
        <div
          className={styles.setting__button}
          onClick={() => setIsOpenModal && setIsOpenModal(true)}
        >
          <Setting />
        </div>
      )}
    </div>
  );
};
